export default "__VITE_ASSET__BVOxg3MF__"